import React from 'react';
import { FieldProps } from 'formik';
import { TextFieldProps } from '@lifeomic/chroma-react/components/TextField';
import { FormikMaskedTextField } from '../MaskedTextField';

export const socialSecurityNumberInputMask = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export interface SocialSecurityNumberTextFieldOwnProps {
  validateInput: (val: string) => string;
  input?: TextFieldProps;
  disabled?: boolean;
}

export type SocialSecurityNumberTextFieldProps = FieldProps &
  SocialSecurityNumberTextFieldOwnProps;

const SocialSecurityNumberTextField = (
  props: SocialSecurityNumberTextFieldProps,
) => {
  const { validateInput, disabled, ...toPass } = props;

  const getInputMask = (rawValue: string) => {
    if (!rawValue) return socialSecurityNumberInputMask;

    // create a mask that will match the valid inputted social security number exactly
    return new Array(rawValue.length).fill(/.*/);
  };

  return (
    <FormikMaskedTextField
      {...toPass}
      mask={getInputMask}
      placeholder="123-45-6789"
      placeholderChar={'_'}
      disabled={disabled}
    />
  );
};

export default React.memo(SocialSecurityNumberTextField);
